import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerResult } from '../utils/errors'

export type MenuImportItem = {
	name: string
	type: 'PRODUCT' | 'OPTION'
	status: 'IMPORTABLE' | 'PREPACKED' | 'ALCOHOL' | 'UNDECLARED'
	gaps: { label: string; reasons: string[] }[]
}

// Was der Erstimport anlegt.
export type MenuImportCounts = {
	categories: number
	products: number
	optionGroups: number
	options: number
}

// Importiert einen Kartenstand als neue Menü-Version im Status IMPORTED; was dabei ankommt, zeigt
// vorher menuImportReport.
const importMenu = async ({
	restaurantId,
	source,
}: {
	restaurantId: string
	source: string
}): Promise<MutationHandlerResult> => {
	try {
		const { errors } = await client.mutate({
			mutation: gql`
				mutation ImportMenu($restaurantId: ID!, $source: String!) {
					importMenu(restaurantId: $restaurantId, source: $source) {
						success
					}
				}
			`,
			variables: { restaurantId, source },
			refetchQueries: ['CurrentUser'],
			awaitRefetchQueries: true,
		})

		if (errors) {
			return { success: false, errors }
		}

		return { success: true, errors: null }
	} catch (e) {
		if (e instanceof Error && 'networkError' in e && e.networkError) {
			return { success: false, errors: 'NETWORK_ERROR' }
		}
		throw e
	}
}

export default importMenu
